import React, { useMemo } from 'react'
import { Popup, Icon, Form, Checkbox } from 'semantic-ui-react'
import RatesDropDown from '../../components/shared/RatesDropDown'
import PropTypes from 'prop-types'
import { useTextResources } from '../../language'
import { useLocalStorageState } from '../../hooks/useLocalStorageState'
import { RateCategory } from '../../components/shared/constants'

const SettingsPopup = ({ HotelID, onChange }) => {
    const text = useTextResources()

    const [allSettings, setAllSettings] = useLocalStorageState("CalendarHotelSettings")

    const setShowRestrictions = checked=>{
        const updated = {...allSettings}
        updated[HotelID] = {
            ...updated[HotelID],
            showRestrictions: checked
        }
        setAllSettings(updated)
        onChange(updated)
    }

    const setShowPrices = checked=>{
        const updated = {...allSettings}
        updated[HotelID] = {
            ...updated[HotelID],
            showPrices: checked
        }
        setAllSettings(updated)
        onChange(updated)
    }

    const setRateItem = rate=>{
        const updated = {...allSettings}
        if (rate) {
            updated[HotelID] = {
                ...updated[HotelID],
                rateName: rate.Name,
                selectedRate: rate.Id
            }
        } else {
            updated[HotelID] = {
                ...updated[HotelID],
                rateName: "",
                selectedRate: null
            }
        }
        setAllSettings(updated)
        onChange(updated)
    }

    /* Allow search in rate
    Add product selection
    Change to => Update price
    Checkbox
    */

    const RatesSpec =  useMemo(()=>{
        let spec = {
            HotelID,
            IncludeDayUse: true,
            IncludeRatePricingType: true,
            IsActive: true,
            ExcludeRateCategoryIDs: [RateCategory.ExtraAddOn, RateCategory.DerivedPromotion]
        }
        return spec
    }, [])

    const settings = allSettings[HotelID] || {}

    return <Popup trigger={
        <Icon name="setting" link></Icon>
    } position="bottom right" basic on="click" >
        <Popup.Header>Hotel View Settings</Popup.Header>
        <Popup.Content>
            <Form>
                <Form.Field label="Selected rate" search placeholder={text("NothingSelected")} spec={RatesSpec} clearable control={RatesDropDown} value={settings && settings.selectedRate}
                onChangeItem={setRateItem} />
                {/* <Form.Field label={text("Product")} control={ProductsDropDown} spec={ProductsSpec}/> */}
                <Form.Field label="Show Prices" control={Checkbox} defaultChecked={settings.showPrices} onChange={(e, {checked})=>setShowPrices(checked)}/>
                <Form.Field label="Show Restrictions" control={Checkbox} defaultChecked={settings.showRestrictions} onChange={(e, {checked})=>setShowRestrictions(checked)}/>
            </Form>
        </Popup.Content>
    </Popup>
}

SettingsPopup.propTypes = {
    HotelID: PropTypes.number,
    onChange: PropTypes.func
}
export default SettingsPopup
